module.exports = __webpack_public_path__ + "img/RedPanda.74ee9144.png";